export enum ShareModalItemTypeEnum {
  COLLECTION = 'Collection',
  MINDITEM = 'MindItem',
  COURSE = 'Course',
  PRODUCT = 'Product'
}
